import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PendingChangesService } from 'src/app/core/services/app/pending-changes.service';
import { NotificationService } from 'src/app/core/services/app/notification.service';
import { BusinessContextService } from 'src/app/core/services/domain/business-context.service';
import { JobService } from 'src/app/core/services/domain/job.service';
import { BaseEntryPageComponent } from 'src/app/shared/components/base/base-entry-page.component';
import { JobModel } from 'src/app/shared/models/domain/job.model';
import { RoutingService } from 'src/app/core/services/app/routing.service';

@Component({
  selector: 'app-job-form-dialog',
  templateUrl: './job-form-dialog.component.html'
})
export class JobFormDialogComponent extends BaseEntryPageComponent<JobModel> {
  constructor(
    public dialogRef: MatDialogRef<JobFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: {name: string },
    private businessContextService: BusinessContextService,
    private jobService: JobService,
    routingService: RoutingService,
    notificationService: NotificationService, pendingChangesService: PendingChangesService) {
    super(notificationService, routingService, pendingChangesService);
  }

  ngOnInit(): void {
    this.value = <JobModel>{
      name: this.dialogData?.name ?? null,
      businessKey: this.businessContextService.currentBusiness.businessKey
    };
  }

  onSaveClicked(): void {
    this.isSaving = true;
    this.jobService.create(this.value).subscribe(key => {
      this.onSaveSuccess('Job was created successfully.');
      this.dialogRef.close(key);
    }, err => {
      this.onSaveFailed(err);
    });
  }

  onCancelClicked(): void {
    this.dialogRef.close(false);
  }
}
